import { getSearchLocalizedValue, getSearchJoinedLocalizedValues } from './get-search-localized-value.js';

const createAltTag = (variant, locale, labels)=>{
    var ref;
    const brand = variant.brand || '';
    const accessoireType = getSearchLocalizedValue(variant, 'accessoryType', locale);
    const accessoireColor = getSearchJoinedLocalizedValues(variant, 'accessoryColor', locale);
    var ref1;
    const frameColor = (ref1 = getSearchJoinedLocalizedValues(variant, 'frameColor', locale)) !== null && ref1 !== void 0 ? ref1 : '';
    var ref2;
    const lensColor = (ref2 = getSearchLocalizedValue(variant, 'lensColor', locale)) !== null && ref2 !== void 0 ? ref2 : '';
    const replacementFrequency = getSearchLocalizedValue(variant, 'replacementFrequency', locale);
    const solutionType = (ref = variant.solutionType) === null || ref === void 0 ? void 0 : ref.toString().replace('Eye drops', '');
    const packageOption = variant.packageOption;
    const colorsLabel = [
        lensColor,
        frameColor
    ].filter((s)=>s.trim() !== ''
    ).join(' / ');
    const packageQuantity = variant.packageQuantity;
    const packageQuantityLabel = packageQuantity && `${packageQuantity} ${packageQuantity === 1 ? labels.lens : labels.lenses} ${labels.perBox}`;
    return [
        brand,
        variant.name,
        solutionType,
        packageOption,
        replacementFrequency,
        packageQuantityLabel,
        colorsLabel,
        accessoireType,
        accessoireColor, 
    ].filter(Boolean).filter((entry)=>entry != ''
    ).join(' ');
};

export { createAltTag };
//# sourceMappingURL=create-alt-tag.js.map
